import { memo } from "react";
import { Box, Typography } from "@mui/material";
import { CustomCheckbox } from "../../CustomCheckbox";

export const AccountsItem = memo(
  ({
    id,
    toggleSingle,
    name,
    isSelected,
  }: {
    id: string;
    toggleSingle: (id: string) => void;
    name: string;
    isSelected: boolean;
  }) => {
    return (
      <Box
        key={id}
        sx={{
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
        }}
        onClick={() => toggleSingle(id)}
      >
        <CustomCheckbox checked={isSelected} />
        <Typography color="#1F2932">{name}</Typography>
      </Box>
    );
  },
);
